import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const reportSelector = createSelector(selfSelector, (rejectsReport) => rejectsReport.report);

export default reportSelector;
